/* eslint-disable max-len */
import React from 'react';
import Loader from '../Loader';
import { motion } from "framer-motion";

const UpdateButton = ({ButtonName, loading, handleOnCLick,classKey, id, disabled, width}) => {
    return (
        <div
            onClick={(e) => handleOnCLick(e)}
        >
            <motion.button
                type="button"
                id={id ? id : "add_admin"}
                disabled={disabled || loading}
                className={classKey ? classKey : `actn-btn1`}
                //when button is loading, setting the width so as not to let the button shrinked
                style={{ 
                    ...(loading && {
                        width: (ButtonName === 'Update' || ButtonName === 'Upload') ? '96px' : (width ? width : 'auto'),
                        cursor: 'default' 
                    })
                }} 
                
            >
                {loading ? <span>{<Loader />}</span> : ButtonName}
            </motion.button>
        </div>
    );
}

export default UpdateButton;
